export const localServer = "http://localhost:5152";
// export const appEngineServer = "https://emr-project-440103.uc.r.appspot.com";
export const googleServer = "https://api.aemr4all.com";

